<template>
  <div class="root">
    <Background />

    <FontAwesomeIcon
      :icon="faAngleDoubleLeft"
      class="close-button"
      @click="navigateToFlourishApp()"
    />
    <img
      src="@/assets/images/flourish-logotipo.png"
      alt="flourish logotipo"
      width="100"
      height="40"
      class="flourish-logotipo"
    />

    <div class="main">
      <div class="images-section">
        <img
          src="@/assets/images/trivia-logo.png"
          alt="trivia logo"
          width="150"
          height="150"
        />
        <img
          src="@/assets/images/coins.svg"
          alt="coins"
          width="87"
          height="153"
        />
      </div>
      <div class="content">
        <div class="presentation-section">
          <span class="title">Money Trivia</span>
          <span class="text">Weekly challenge!</span>
        </div>

        <div class="explanation-section">
          <div class="questionsAndReward">
            <span class="title">Questions</span>
            <span v-if="loadedQuestions.length > 0" class="text">{{
              loadedQuestions.length
            }}</span>
            <skeleton-box v-else></skeleton-box>
          </div>
          <div class="questionsAndReward">
            <span class="title">Reward</span>
            <div
              class="reward"
              :class="{ 'reward--loading': loadedQuestions.length <= 0 }"
            >
              <span v-if="loadedQuestions.length > 0" class="text">{{
                maxWinnableCoinsAmount
              }}</span>
              <skeleton-box v-else></skeleton-box>
              <img
                src="@/assets/images/flourish-coin-darker.svg"
                width="30"
                height="30"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <p v-if="loadedPlayerName" class="text-pill text-pill--name">
          {{ loadedPlayerName }}
        </p>
        <skeleton-box v-else class="text-pill text-pill--name"></skeleton-box>
        <span class="footer-text"
          >💡 Answer the best you can as fast as you can!</span
        >
        <button
          @click="loadGame()"
          class="confirm"
          :class="{ disabled: loadedQuestions.length <= 0 }"
          :disabled="loadedQuestions.length <= 0"
        >
          Play for Free
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Background from "../components/Background";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";
import { routesName } from "../router";
import { mapActions, mapState } from "vuex";
import SkeletonBox from "../components/SkeletonBox.vue";

export default {
  components: {
    Background,
    SkeletonBox,
  },
  data() {
    return {
      faAngleDoubleLeft,
    };
  },
  methods: {
    ...mapActions(["closeGame", "getQuestions"]),
    loadGame() {
      let eventName = process.env.VUE_APP_ANALYTICS_EVENT_BASE + "GameStarted";
      this.$logEvent(eventName);
      this.$router.push(routesName.countdown);
    },
    navigateToFlourishApp() {
      this.closeGame("no-redirect");
    },
  },
  computed: {
    ...mapState(["playerName", "questions"]),
    loadedQuestions() {
      return this.questions;
    },
    loadedPlayerName() {
      return this.playerName;
    },
    maxWinnableCoinsAmount() {
      return this.loadedQuestions.reduce((counter, question) => {
        return question.coins + counter;
      }, 3);
    },
  },
  mounted() {
    this.getQuestions();
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

@media only screen and (min-width: 600px) {
  .root {
    max-width: 375px;
  }
}

.root {
  min-width: 320px;
  min-height: 570px;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
}

.flourish-logotipo {
  position: absolute;
  top: 1rem;
  margin: 0 auto;
}

.close-button {
  position: absolute;
  top: 1.7rem;
  left: 1rem;
  margin: 0 auto;
  color: white;
}

.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.images-section {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 3rem;
  flex: 1;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 80%;
  margin-bottom: 3rem;
  flex: 1;
}

.presentation-section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  align-self: flex-start;
}

.presentation-section > .title {
  font-family: $secondary-font;
  font-size: 2rem;
  color: $quaternary;
}

.presentation-section > .text {
  font-family: $primary-font;
  font-size: 1rem;
  align-items: center;
  color: $quaternary-lighter;
  margin: 0.5rem 0 2rem 0;
}

.explanation-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.questionsAndReward {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0;
}

.reward {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin: 0 1rem;
}

.reward--loading {
  width: 100%;
}

.questionsAndReward > .title {
  width: 100%;
  background-color: $primary-alternative;
  border-radius: 20px;
  padding: 0.4rem 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 4px 4px 0 rgba(#000, 0.4),
    0 6px 4px 0 rgba($quinternary-darker, 0.2);
  position: relative;
  font-family: $secondary-font;
  font-size: 1rem;
  text-align: center;
  color: $quaternary;
  box-sizing: border-box;
}

.questionsAndReward > .text,
.questionsAndReward > .reward > .text {
  position: relative;
  font-family: $secondary-font;
  font-size: 2rem;
  color: $quaternary-lighter;
}

.footer {
  box-sizing: border-box;
  position: relative;
  bottom: 0;
  width: 100%;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: $quaternary-darker;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.footer-text {
  font-family: $primary-font;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  margin-top: 1rem;
  color: $primary;
  max-width: 25ch;
}

.text-pill {
  background: $primary-alternative;
  border-radius: 28px;
  padding: 0.3rem 0.8rem;
  margin-bottom: 0.5rem;

  font-family: $primary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: $quaternary-darker;
}

.text-pill--name {
  font-size: 16px;
  position: absolute;
  padding: 0.5rem;
  width: 50%;
}

// SAFARI STYLE

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .text-pill--name {
    margin: -6rem auto;
  }
}

// CHROME STYLE

@media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
  .text-pill--name {
    margin: 0 auto 12rem auto;
  }
}
</style>
